// The ONE catalog every inventory screen reads (rep portal "My inventory", admin Rep
// Inventory tab, the Adjust baseline, the delete-impact figure): the live products +
// kits from SHARED_PRODUCTS (hydrated from Supabase portal_products), and only when
// the shared store is still empty the read-only display fallback the rep portal has
// always used. READ ONLY: nothing here writes to Supabase or to the shared store.
import SHARED_PRODUCTS from "./sharedProducts";
import { REP_FALLBACK_PRODUCTS, REP_FALLBACK_KITS } from "./seeds/catalogSeed";

export function inventoryCatalog() {
  const active = SHARED_PRODUCTS.getActive();
  const activeKits = SHARED_PRODUCTS.getActiveKits();
  const prods = active.length > 0 ? active : REP_FALLBACK_PRODUCTS;
  const kits = activeKits.length > 0 ? activeKits.map((k) => ({ ...k, isKit: true })) : REP_FALLBACK_KITS;
  return [...prods, ...kits];
}
